
<template>
  <div id="app">
    <Layout />
  </div>
</template>

<script>
import Layout from "@/views/main.vue";
export default {
  name: "App",
  components: {
    Layout,
  },
};
</script>

<style lang="scss">
html,
body,
#app,
.full-wrapper {
  width: 100%;
  height: 100%;
  margin: 0;
  background: #fff;
  /* 适用于 Webkit 浏览器（例如 Chrome、Safari） */
  // ::-webkit-scrollbar {
  //   display: none;
  // }

  // /* 适用于 Firefox */
  // scrollbar-width: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #333;
  overflow-x: hidden;
  //margin-top: 45px;
  background-color: #fff;
  box-sizing: border-box;
  p {
    margin: auto;
  }
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.5em;
  /*border-radius: 50%;*/
  height: 2em !important;
  line-height: 2em !important;
  margin-top: -1em !important;
}

.video-js:hover .vjs-big-play-button,
.vjs-custom-skin > .video-js .vjs-big-play-button:focus,
.vjs-custom-skin > .video-js .vjs-big-play-button:active {
  background-color: rgba(0, 0, 0, 0.45) !important;
}

.vjs-custom-skin > .video-js .vjs-loading-spinner {
  border-color: rgba(0, 0, 0, 0.45) !important;
}
.vjs-custom-skin > .video-js .vjs-play-progress,
.vjs-custom-skin > .video-js .vjs-volume-level {
  background-color: rgba(0, 0, 0, 0.45) !important;
}
.vjs-custom-skin > .video-js .vjs-control-bar {
  /*background-color: rgba(0,0,0,0.3) !important;*/
  color: #ffffff;
  font-size: 14px;
}
.vjs-custom-skin {
  border-radius: 0.8208vw; /* 调整圆角大小 */
  overflow: hidden;
}
.vjs-has-started.vjs-paused {
  .vjs-big-play-button {
    display: none !important;
  }
}
</style>